// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"89247e11","787":"1f066733","983":"4e13a41c"}[chunkId] + ".chunk.js";
};